import React from 'react';
import WebinarsList from './Webinars/List.jsx'

function Dashboard({
  webinars,
  webinarsCount,
  paginationProps,
  showUsersModal
}) {
  return (
    <div>
      <main className="site--width clearfix-c">
        <div className="container_statistics">
          <div className="container_result_statistic clearfix-c">
            <h5>Webinar statistics</h5>
            <h6>Total created webinars - {webinarsCount}</h6>
            <WebinarsList
              values={webinars}
              paginationProps={paginationProps}
              showUsersModal={showUsersModal}
            />
          </div>
        </div>
      </main>
    </div>
  );
}

Dashboard.defaultProps = {};

Dashboard.propTypes = {};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/Statistics/Statistics.jsx